module.exports = __webpack_public_path__ + "static/media/tractor.96c1ff71.svg";